var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecialSeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14626_7247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.157 8.70076C16.8735 8.70076 18.2649 7.34983 18.2649 5.68339C18.2649 4.01694 16.8735 2.66602 15.157 2.66602C13.4405 2.66602 12.0491 4.01694 12.0491 5.68339C12.0491 7.34983 13.4405 8.70076 15.157 8.70076Z",
    fill: "#D14545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.919 27.7175C27.0544 27.9645 26.9591 28.2746 26.7083 28.4029L25.5822 28.9791C25.341 29.1025 25.0454 29.0113 24.9156 28.7735L22.2843 23.9518C22.109 23.6306 21.7724 23.4308 21.4065 23.4308H18.6331V21.2207H22.1757C22.9076 21.2207 23.5811 21.6206 23.9316 22.2632L24.2219 22.7956L26.919 27.7175Z",
    fill: "#D14545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.633 9.24414H14.0491C13.1063 9.24414 12.6349 9.24414 12.342 9.53703C12.0491 9.82993 12.0491 10.3013 12.0491 11.2441V21.4311C12.0491 22.3739 12.0491 22.8453 12.342 23.1382C12.6349 23.4311 13.1063 23.4311 14.0491 23.4311H18.633V11.2441C18.633 10.3013 18.633 9.82993 18.3401 9.53703C18.0472 9.24414 17.5758 9.24414 16.633 9.24414Z",
    fill: "#D14545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1859 15.2249C23.1859 15.5293 23.0632 15.8072 22.8587 16.0058C22.6543 16.2043 22.368 16.3234 22.0545 16.3234H18.6331V14.1133H22.0545C22.6815 14.1133 23.1995 14.6029 23.1995 15.2249H23.1859Z",
    fill: "#D14545"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5212 16.3894C9.80961 16.3894 6.92686 19.8778 8.18379 23.6969L8.18453 23.6992C8.69612 25.2665 10.0135 26.5393 11.6413 27.0513C15.5697 28.2806 19.1646 25.475 19.1646 21.8683H21.2092C21.2092 26.7841 16.2988 30.5953 11.0128 28.9403L11.0115 28.9399C8.76858 28.2345 6.95118 26.4905 6.23574 24.3C4.54927 19.1733 8.45468 14.4043 13.5212 14.4043V16.3894Z",
    fill: "#D14545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14626_7247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3329,
    height: 26.6667,
    fill: "white",
    transform: "translate(5.83325 2.66602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialSeat);
export default __webpack_public_path__ + "static/media/specialSeat.af08cd7f90767f8d50a2e2e109fb7dca.svg";
export { ForwardRef as ReactComponent };